var exports = {
  "kL": "xcc377c0b--109d61--container",
  "Sl": "xcc377c0b--109d61--image",
  "DD": "xcc377c0b--109d61--title",
  "UE": "xcc377c0b--109d61--arrow",
  "Y9": "xcc377c0b--109d61--arrow-hovered",
  "kA": "xcc377c0b--109d61--icon-container",
};

module.exports = exports;
